import { render, staticRenderFns } from "./index.vue?vue&type=template&id=54183c4f&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/__socialLogin.scss?vue&type=style&index=0&id=54183c4f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54183c4f",
  null
  
)

export default component.exports